<template>
  <div class="main">
    <div class='step1' v-if="(step==0)">
      <div class='logo'>
        <img class='logo_img' src="../assets/message.svg">
      </div>
      <div class='step1_text'>WHO CHAT</div>
      <div><input class='nickname' type='text' v-model="nickname"  placeholder="請輸入你的暱稱"/></div>
       <div><button class='step1_btn' @click="toChat" ><div>確認</div></button></div>
    </div>
    <div class='step2' v-if="(step==1)">
      <div class='chat' ref='chat'>
        <div class='chat_messages'>
          <div class='' :key="index" v-for="(item, index) in messages">
            <div class="chat_user" :class="{ right: item.name==nickname }"  >
              <div class='chat_user_name' :class="{ right: item.name==nickname }" v-show='messages[index-1]==undefined || item.name!==messages[index-1].name'>{{item.name}}</div>
              <div class='chat_user_text_time' :class="{ right: item.name==nickname }">
                <div class='chat_user_text' :class="{ right: item.name==nickname }">{{item.msg}}</div>
                <div class='chat_user_time'> {{ item.timestamp | timeFormat}} </div>
              </div>
            </div>
          </div>
        </div>
        <div class='chat_bar'>
        <input class='chat_msg' v-model="message" @keyup.enter="send" />
        <div class='chat_icon'><img src="../assets/emoji.svg" @click="todo"></div>
        <div class='chat_icon'><img src="../assets/file.svg" @click="todo"></div>
      </div>
      </div>
      <div class='back' @click='back'>←</div>

     
    </div>
  </div>  
</template>

<script>
// RecentDocuments.vue
import { db } from '../db'
import firebase from 'firebase/app'
import moment from 'moment'

// const channel = db.collection('channel_001')

export default {

  data() {
    return {
      step:0,
      nickname:null,
      channel:null,
      messages: [],
      message:null,
      firebase:firebase
    }
  },
  mounted(){
    this.channel = db.collection('channel_001')
  },
  firestore () {
    return {
      messages:  db.collection('channel_001').orderBy('timestamp','asc')
    }
  },
  computed:{
    tt: function(){
      return this.text;

    }
  },
  updated: function(){
    if (this.step != 1) return;
    // this.$refs.chat.scrollTop = this.$refs.chat.scrollHeight;
  },
  watch:{

  },
  filters: {
    timeFormat(t) {
      if (t == null) return '';
      var date = t.toDate();
      return moment.unix(date.getTime() / 1000).format('hh:mm a')
    }
  },
  methods:{
    todo(){
      alert('OOPS!');
    },
    back(){
       var leave = confirm('確定要離開聊天室？');
       if (leave){
         this.nickname = null;
         this.step = 0
       }
    },
    toChat(){
      if (this.nickname == null) {
        alert('請輸入你的暱稱');
        return false;
      }
      this.step = 1;
    },
    send(){
      var timestamp = firebase.firestore.FieldValue.serverTimestamp();
      var message = this.message;
      if (message == null) return;

      this.channel.add({
        msg: message,
        timestamp: timestamp,
        name:this.nickname
      })
      this.message =  null;
    }
  }
}


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.step1{
  width: 100vw;
  height: 100vh;
  position: relative;
  display: flex;
  background: linear-gradient(240deg, #D37C3C, #FE8A74 10% , #FD6895);
  justify-content: center;
  flex-direction: column;
}

.step2{
  width: 100vw;
  height: 100vh;
  position: relative;
  display: flex;
  background: linear-gradient(to right, rgba(253,104,149 ,35%), rgba(254,138,116,40%));
  justify-content: flex-end;
  flex-direction: column;
}

.logo {
  background: #fff;
  width:208px;
  height:208px; 
  border-radius: 25px;
  overflow: hidden;
  margin: 0 auto;
  position: relative;
}

.logo_img {
  position:relative;
  left: 0;
  top:-70px;
}

.nickname{
  padding-top: 10px;
  width:230px;
  size:10px;
  margin: 10px;
  border: 0;
  outline: 0;
  background: transparent;
  border-bottom: 1px solid #fff;
  font-size:24px;
  color: #fff;
}

.step1_text{
  margin: 10px;
  text-align: center;
  font-style:'Roboto';
  font-size: 63px ;
  letter-spacing: 0;
  color: #FFFFFF;
}

.step1_btn{
  margin: 10px;
  width: 208px;
  height: 60px;
  cursor: pointer;

  background: #FFFFFF74 0% 0% no-repeat padding-box;
  border: 1px solid #FFFFFF;
  border-radius: 9px;
}

.step1_btn  > div{
  font: Bold 28px/48px 'Noto Sans T Chinese';
  pointer-events: none;
  cursor: pointer;
  letter-spacing: 0;
  color: #FFFFFF;
  opacity: 1;
}

.chat{
  position: relative;
  margin:0 auto;
  width:60%;
  min-height: 100px;
  max-height: 450px;
  padding: 10px;
  overflow:auto;
  background-color:#F3F4F8;
  border-radius: 8px;
  display:flex;
  flex-direction: column-reverse;
  margin-bottom:68px;
  /* bottom: 68px; */
}

.back{
  cursor: pointer;
  background-color: #FE7E80;
  position: fixed;
  top:0px;
  line-height: 48px;
  left:0px;
  width: 48px;
  height: 48px;
  text-align: center;
  font-size:30px;
  color: #fff;
}


.chat_bar{
  background-color: #F8F8F8;
  position: fixed;
  left:0px;
  bottom: 0px;
  width: 100%;
  height: 68px;
  text-align: center;
  font-size:30px;
  color: #fff;
  display:flex;
  
}

.chat_msg{
  size:10px;
  margin: 10px;
  font-size:24px;
  border: none; 
  border:solid 1px #ccc;
  border-radius: 10px;
  padding-left:20px;
  color: #000;
  flex:auto;
}

.chat_icon{
  padding-top: 5px;
  margin: 10px;
}

.chat_messages{
   width: 100%;
}

.chat_user{
  width:95%;
  margin:2px;
  padding: 4px;
  display: flex;
  flex-direction: column;
}

.chat_user.right{
  /* flex-direction:column-reverse; */
  /* flex-direction: row-reverse;
  justify-content: flex-; */
} 


.chat_user_name{
  align-self: flex-start;
  color: #BABABA;
  font-style: 'Noto Sans T Chinese';
  font-size: 18px;
}

.chat_user_name.right{
  align-self: flex-end;
  color: #FE7E80;

}

.chat_user_time{
  color:#BABABA;
  margin-left: 3px;
  margin-right: 3px;
  font-size:12px;
  vertical-align: bottom;
  align-self:flex-end;
}

.chat_user_text{
  font-style: 'Noto Sans T Chinese';
  border-radius: 4px;
  background: #E2E0E0;
  padding:8px;
}

.chat_user_text.right{
  color: #fff;
  background: #FE7E80;
}
.chat_user_text_time{
  margin: 2px;
  display:flex;
}

.chat_user_text_time.right{
  flex-direction: row-reverse;
}




.back{
  background-color: #FE7E80;
  position: fixed;
  top:0px;
  line-height: 48px;
  left:0px;
  width: 48px;
  height: 48px;
  text-align: center;
  font-size:30px;
  color: #fff;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
